import React, { useState } from 'react';
import { MainContent, FormContainer, ContentWrapper } from '../components/Containers';
import SectionTitle from '../components/SectionTitle';
import SettingsMeForm from '../components/SettingsMeForm';
import { useMeSettings } from '../hooks/useMeSettings';
import LoadingIndicator from '../components/LoadingIndicator';
import { useTranslation, Trans } from 'react-i18next';
import InlineAlert from '../components/InlineAlert';
import { ApiErrorMessage } from '../components/ApiErrorMessage';
import { Link } from '@increasecard/typed-components';
import config from '../config';
import { ScreenSeparator } from '../components/common/ScreenSeparator';

function SettingsMe() {
  const [apiError, setApiError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const { t } = useTranslation('settingsMe');
  const { meSettings, updateMeSettings } = useMeSettings();

  const onSubmit = async (values) => {
    try {
      setApiError(null);
      setSuccessMessage(null);

      await updateMeSettings(meSettings.id, values);
      setSuccessMessage(t('savedSuccessfully'));
      setApiError(null);
    } catch (error) {
      setApiError(error);
      setSuccessMessage(null);
    }
  };

  function onSuccessMessageClose() {
    setSuccessMessage(null);
  }

  const loadingUser = meSettings === null;

  return (
    <ContentWrapper>
      <MainContent>
        <SectionTitle>{t('title')}</SectionTitle>
        <p>
          <Trans i18nKey="settingsMe:userSettingsDescription" t={t} />
        </p>
        <FormContainer>
          {loadingUser ? (
            <LoadingIndicator />
          ) : (
            <SettingsMeForm
              initialValues={meSettings}
              onSubmit={onSubmit}
              submitText={t('submitForm')}
            />
          )}
        </FormContainer>
        {successMessage && (
          <InlineAlert
            message={successMessage}
            onClose={onSuccessMessageClose}
            style={{ marginTop: '40px' }}
            variant="info"
          />
        )}
        <ApiErrorMessage error={apiError} marginTop={40} />
        <ScreenSeparator margin="40px 0" />
        <SectionTitle as="h2" style={{ fontSize: '24px' }}>
          {t('settingsMe:passwordSectionTitle')}
        </SectionTitle>
        <p>{t('settingsMe:passwordSectionDescription')}</p>
        <Link href={`${config.authUrl}/password/change`} target="_blank">
          {t('common:changePassword')}
        </Link>
      </MainContent>
    </ContentWrapper>
  );
}

export default SettingsMe;
